import { render, staticRenderFns } from "./BagExplorer.vue?vue&type=template&id=539b23e8&scoped=true&"
import script from "./BagExplorer.vue?vue&type=script&lang=js&"
export * from "./BagExplorer.vue?vue&type=script&lang=js&"
import style0 from "./BagExplorer.vue?vue&type=style&index=0&id=539b23e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b23e8",
  null
  
)

export default component.exports